// General
import "./banner.scss";
import { useState, useEffect, useLayoutEffect, useRef } from "react";
// Services
import {
  useLazyGetProfileQuery,
  useLazyGetUserAioQuery,
  useLazyGetBannerListQuery,
  useTrackBannerMutation,
} from "../../../../services/data.service";
// Static Data
import routeConst from "../../../../const/routeConst";
// Redux
import { useSelector, useDispatch } from "react-redux";
import {
  updateViewedMeBanners,
  updateProfileBanners,
  updateDiamondsWithdrawalInfoDialogBanner,
} from "../../../../redux/store/bannerStore";
import { updatePaymentTag } from "../../../../redux/store/paymentStore";
import { updateLeaderboardTab } from "../../../../redux/store/leaderboardStore";
import {
  updateLeaderboardEventsDialog,
  updateOnboardingPrivateRoomBabyDialog,
  updateOnboardingPrivateRoomDaddyDialog,
  updateOnboardingSugarbookVerifiedDialog,
  updateUpdateTorDialog,
} from "../../../../redux/store/dialogStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// i18next
import { useTranslation } from "react-i18next";
// Moment
import moment from "moment";
// Custom Hooks
import useIsMounted from "../../../utility/custom-hooks/useIsMounted-hook";
import useCustomNavigate from "../../../utility/custom-hooks/useCustomNavigate-hook";

const Banner = (props) => {
  const { type, view = "carousel" } = props;

  // API variables
  const [
    getProfile,
    {
      data: getProfileData,
      error: getProfileErrorData,
      isFetching: getProfileFetching,
      isLoading: getProfileLoading,
      isSuccess: getProfileSuccess,
      isError: getProfileError,
    },
  ] = useLazyGetProfileQuery();
  const [
    getUserAio,
    {
      data: getUserAioData,
      error: getUserAioErrorData,
      isFetching: getUserAioFetching,
      isLoading: getUserAioLoading,
      isSuccess: getUserAioSuccess,
      isError: getUserAioError,
    },
  ] = useLazyGetUserAioQuery();
  const [
    getBannerList,
    {
      data: getBannerListData,
      error: getBannerListErrorData,
      isFetching: getBannerListFetching,
      isLoading: getBannerListLoading,
      isSuccess: getBannerListSuccess,
      isError: getBannerListError,
    },
  ] = useLazyGetBannerListQuery();
  const [
    trackBanner,
    {
      data: trackBannerData,
      error: trackBannerErrorData,
      isLoading: trackBannerLoading,
      isSuccess: trackBannerSuccess,
      isError: trackBannerError,
    },
  ] = useTrackBannerMutation();

  // General variables
  // ponytail: ref, not state — nothing renders from it, and as state the unmount
  // cleanup closed over the initial [] so intervals were never actually cleared
  const timerObj = useRef([]);
  const [expandBanner, setExpandBanner] = useState({});
  const [livestreamBanners, setLivestreamBanners] = useState([]);

  // FLIP animation refs
  const rootRef = useRef(null);
  const bannerRefs = useRef({});
  const firstPositionsRef = useRef(null);
  const expandDelayRef = useRef(null);

  // Render variables
  const [carouselView, setCarouselView] = useState([]);

  // Redux variables
  const viewedMeBanners = useSelector((state) => state.banner.viewedMeBanners);
  const profileBanners = useSelector((state) => state.banner.profileBanners);
  const diamondsWithdrawalInfoDialogBanner = useSelector(
    (state) => state.banner.diamondsWithdrawalInfoDialogBanner
  );
  const dispatch = useDispatch();

  // i18next variables
  const { t } = useTranslation();

  // Custom Hooks Functions
  const mounted = useIsMounted();
  const onNavigate = useCustomNavigate();

  // Lifecycle | Mounted
  useEffect(() => {
    getProfile(null, true);
    getUserAio(null, true);
  }, []);

  // Lifecycle | Unmounted
  useEffect(() => {
    return () => {
      if (!mounted()) {
        timerObj.current.forEach((count) =>
          clearInterval(count?.timerInterval)
        );
        if (expandDelayRef.current) {
          clearTimeout(expandDelayRef.current);
        }
      }
    };
  }, [mounted]);

  // Lifecycle | Check for update | User AIO API Response
  useEffect(() => {
    if (getUserAioLoading) {
    } else if (getUserAioSuccess && getProfileSuccess) {
      if (getUserAioData?.status === 1) {
        let banners = getUserAioData?.data?.promotions?.p_20210818?.graphics;
        let cashoutBanner = getUserAioData?.data?.urls?.cash_out_banner;

        // Organize Viewed Me Banners
        if (viewedMeBanners?.length <= 0) {
          if (banners?.length > 0) {
            for (let i = 0; i < banners?.length; i++) {
              if (banners[i]?.view === "viewed_me") {
                if (getProfileData?.data?.membership_type === "free") {
                  if (banners[i]?.constant?.includes("fifty_percent_off")) {
                    dispatch(updateViewedMeBanners(banners[i]));
                  }
                } else {
                  if (banners[i]?.constant?.includes("twenty_percent_off")) {
                    dispatch(updateViewedMeBanners(banners[i]));
                  }
                }
              }
            }
          }
        }

        // Organize Profile Banners
        if (profileBanners?.length <= 0) {
          if (banners?.length > 0) {
            for (let i = 0; i < banners?.length; i++) {
              if (banners[i]?.view === "profile") {
                if (banners[i]?.type === "banner") {
                  if (getProfileData?.data?.membership_type === "free") {
                    if (banners[i]?.constant?.includes("fifty_percent_off")) {
                      dispatch(updateProfileBanners(banners[i]));
                    }
                  } else {
                    if (banners[i]?.constant?.includes("twenty_percent_off")) {
                      dispatch(updateProfileBanners(banners[i]));
                    }
                  }
                }
              }
            }
          }
        }

        // Organize Diamonds Withdrawal Banners
        if (diamondsWithdrawalInfoDialogBanner?.length <= 0) {
          dispatch(updateDiamondsWithdrawalInfoDialogBanner(cashoutBanner));
        }
      }
    } else if (getUserAioError) {
    }
  }, [
    getUserAioFetching,
    getUserAioLoading,
    getUserAioSuccess,
    getProfileSuccess,
    getUserAioError,
  ]);

  // Lifecycle | Check for update | Banner List API Response
  useEffect(() => {
    if (getBannerListFetching || getBannerListLoading) {
    } else if (getBannerListSuccess) {
      if (getBannerListData?.status === 1) {
        if (getBannerListData?.data?.length > 0) {
          if (type === "livestream") {
            // Initialise ordered list only once (guard prevents reset on re-renders)
            if (livestreamBanners?.length <= 0) {
              organizeLivestreamFloatingTimerObj(getBannerListData?.data);
              setLivestreamBanners(getBannerListData?.data);
            }
            // Livestream banners render directly in JSX return (not via setCarouselView)
            // so that useLayoutEffect FLIP animation works correctly
          } else {
            organizeBannerTimerObj(getBannerListData?.data);

            if (view === "carousel") {
              setCarouselView(
                <div className="carousel-container border-radius">
                  <swiper-container
                    class="swiper-container border-radius"
                    navigation="false"
                    pagination="true"
                    scrollbar="false"
                    // loop="true"
                    speed="300"
                    autoplay-delay="2500"
                  >
                    {getBannerListData?.data?.map((banner, index) => (
                      <swiper-slide
                        class="banner-container"
                        onClick={() => onOpenLink(banner)}
                        key={index}
                      >
                        <img
                          className={`banner-image ${
                            requireRadius() ? "require-radius" : ""
                          }`}
                          src={banner?.asset_url}
                        />
                        <div
                          className={`banner-timer-container ${
                            requireBottomSpace() ? "require-bottom-space" : ""
                          }`}
                          data-banner-timer={banner?.id ?? index}
                          style={{
                            color: banner?.metadata?.countdown_font_color,
                          }}
                        ></div>
                      </swiper-slide>
                    ))}
                  </swiper-container>
                </div>
              );
            } else if (view === "stack") {
              setCarouselView(
                <div className="stack-container">
                  <div className="leaderboard-banner-container border-radius">
                    {getBannerListData?.data?.map((banner, index) => (
                      <div
                        className="banner-container"
                        onClick={() => onOpenLink(banner)}
                        key={index}
                      >
                        <img className="banner-image" src={banner?.asset_url} />
                        <div
                          className="banner-timer-container"
                          data-banner-timer={banner?.id ?? index}
                          style={{
                            color: banner?.metadata?.countdown_font_color,
                          }}
                        ></div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            }
          }
        }
      }
    } else if (getBannerListError) {
    }
  }, [
    getBannerListFetching,
    getBannerListLoading,
    getBannerListSuccess,
    getBannerListError,
    expandBanner,
  ]);

  // Lifecycle | FLIP animation when livestream banners reorder
  useLayoutEffect(() => {
    if (!firstPositionsRef.current) return;
    const firsts = firstPositionsRef.current;
    firstPositionsRef.current = null;

    const timers = [];

    Object.entries(bannerRefs.current).forEach(([key, el]) => {
      if (!el || firsts[key] === undefined) return;
      const last = el.getBoundingClientRect().top;
      const delta = firsts[key] - last;
      if (delta === 0) return;

      // Invert: snap element back to its old visual position
      el.style.transition = "none";
      el.style.transform = `translateY(${delta}px)`;

      // Force reflow so the browser registers the starting transform
      el.getBoundingClientRect();

      // Play: animate position AND preserve the CSS class width/expand transition
      el.style.transition = "transform 0.35s ease, width 0.5s ease";
      el.style.transform = "translateY(0)";

      // Clear inline styles after the longest duration so CSS class transitions
      // (expand, opacity) work normally on subsequent interactions
      const timer = setTimeout(() => {
        el.style.transition = "";
        el.style.transform = "";
      }, 500);
      timers.push(timer);
    });

    return () => timers.forEach(clearTimeout);
  }, [livestreamBanners]);

  // Lifecycle | Check for update | type
  useEffect(() => {
    if (!type) return;

    switch (type) {
      case "leaderboard-livestreaming-normal":
      case "live":
        getBannerList("?category=leaderboard_ls", true);
        break;
      case "ls_top_banner":
        getBannerList("?category=ls_top_banner", true);
        break;
      case "leaderboard-livestreaming-tier-1":
        getBannerList("?category=leaderboard_ls_tier_1", true);
        break;
      case "leaderboard-livestreaming-tier-2":
        getBannerList("?category=leaderboard_ls_tier_2", true);
        break;
      case "leaderboard-livestreaming-tier-3":
        getBannerList("?category=leaderboard_ls_tier_3", true);
        break;
      case "leaderboard-livestreaming-pk":
        getBannerList("?category=leaderboard_ls_pk", true);
        break;
      case "leaderboard-private-call-normal":
        getBannerList("?category=leaderboard_pr", true);
        break;
      case "leaderboard-private-call-events":
        getBannerList("?category=leaderboard_pr", true);
        break;
      case "leaderboard-casino-normal":
      case "live-gaming":
        getBannerList("?category=leaderboard_casino", true);
        break;
      case "leaderboard-gift":
        getBannerList("?category=leaderboard_gift", true);
        break;
      case "leaderboard-race":
        getBannerList("?category=leaderboard_race", true);
        break;
      case "livestream":
        getBannerList("?category=live_floating", true);
        break;
      case "video-call":
      case "search":
        getBannerList("?category=search", true);
        break;
      case "search-masquerade-party":
        getBannerList("?category=masquerade_party", true);
        break;
      case "inbox":
      case "interests":
        getBannerList("?category=inbox", true);
        break;
      case "profile-overview":
      case "video-call-settings":
        getBannerList("?category=profile", true);
        break;
      case "coin-shop":
        getBannerList("?category=coins_shop", true);
        break;
      case "diamonds-withdrawal-dialog":
        getBannerList("?category=diamond_withdrawal", true);
        break;
      case "payment":
        getBannerList("?category=payment", true);
        break;
      default:
        break;
    }
  }, [type, viewedMeBanners, profileBanners]);

  // Events Handler | Button
  const onOpenGiftLeaderboard = () => {
    dispatch(updateLeaderboardTab(5)); // gift tab index in leaderboard.js
    onNavigate(routeConst.leaderboard.path);
  };
  const onOpenEventsLeaderboard = () => {
    dispatch(updateLeaderboardEventsDialog(true));
  };
  const onExpandBanner = (banner) => {
    const id = banner?.id;
    const isAlreadyTop = livestreamBanners?.[0]?.id === id;

    // Clear any pending delayed expand from a previous click
    if (expandDelayRef.current) {
      clearTimeout(expandDelayRef.current);
      expandDelayRef.current = null;
    }

    if (isAlreadyTop) {
      // Already at top: just toggle expand, no reorder needed
      setExpandBanner({ [id]: !expandBanner[id] });
    } else {
      // Not at top: FLIP Step 1 — record positions before reorder
      const firsts = {};
      Object.entries(bannerRefs.current).forEach(([key, el]) => {
        if (el) firsts[key] = el.getBoundingClientRect().top;
      });
      firstPositionsRef.current = firsts;

      // Close all, move to top immediately
      setExpandBanner({});
      setLivestreamBanners((prev) => {
        const idx = prev.findIndex((b) => b?.id === id);
        if (idx <= 0) return prev;
        const reordered = [...prev];
        reordered.splice(idx, 1);
        reordered.unshift(banner);
        return reordered;
      });

      // Open it after the FLIP settles
      expandDelayRef.current = setTimeout(() => {
        setExpandBanner({ [id]: true });
        expandDelayRef.current = null;
      }, 500);
    }
  };
  const onOpenLink = (banner) => {
    if (banner?.id) {
      trackBanner({ banner_id: banner?.id });
    }

    if (type === "livestream") {
      if (banner?.cta === "redirect") {
        if (banner?.url) {
          window.open(banner?.url, "_blank");
        }
      } else if (banner?.cta === "leaderboard_gift") {
        onOpenGiftLeaderboard();
      } else {
        onOpenEventsLeaderboard();
      }
    } else if (banner?.cta === "redirect") {
      if (banner?.url) {
        window.open(banner?.url, "_blank");
      }
    } else if (banner?.cta === "live") {
      onNavigate(routeConst.live.path);
    } else if (banner?.cta === "coin_shop") {
      onNavigate(routeConst.profile.wallet.path);
    } else if (banner?.cta === "game_lobby") {
      onNavigate(routeConst.games.casino.path);
    } else if (banner?.cta === "game_entry") {
      onNavigate(
        `${routeConst.games.casino.path}`,
        false,
        `?game_id=${banner?.metadata?.game_id}&game_title=${banner?.metadata?.game_name}`
      );
    } else if (banner?.cta === "video_call_landing") {
      dispatch(updateOnboardingPrivateRoomDaddyDialog(true));
    } else if (banner?.cta === "premium") {
      dispatch(updatePaymentTag("pwa-search-pivot-banner"));
      onNavigate(routeConst.upgrade.path);
    } else if (banner?.cta === "verified_profile") {
      // dispatch(updateOnboardingSugarbookVerifiedDialog(true));
      onNavigate(routeConst.verify.sugarbookVerified.onboarding.path);
    } else if (banner?.cta === "private_call_recruitment_landing") {
      dispatch(updateOnboardingPrivateRoomBabyDialog(true));
    } else if (banner?.cta === "leaderboard_gift") {
      onOpenGiftLeaderboard();
    } else if (banner?.cta === "tor") {
      dispatch(updateUpdateTorDialog(true));
    } else if (banner?.url) {
      window.open(banner?.url, "_blank");
    }
  };

  // Utility Functions
  const organizeLivestreamFloatingTimerObj = (banners) => {
    if (timerObj.current.length > 0) return;

    const timerObjects = banners?.map((banner, index) => {
      const hasTimer = banner?.metadata?.is_countdown;
      const endEpoch = banner?.metadata?.countdown_end_date_epoch;
      let timerInterval = null;
      let countdown = null;
      let countdownShort = null;

      if (hasTimer) {
        const end = moment.unix(endEpoch);
        timerInterval = setInterval(() => {
          const now = moment();
          const diff = moment.duration(end.diff(now));

          if (diff.asSeconds() <= 0) {
            // Keep the interval running: the short/expanded containers mount
            // and unmount on expand, so a one-off write would be lost
            countdown = t("common.contest_ended");
            countdownShort = t("common.contest_ended");
          } else {
            const days = Math.floor(diff.asDays());
            const hrs = diff.hours();
            const mnts = diff.minutes();
            const seconds = diff.seconds();

            countdown = `Time Left: ${days} DAYS ${hrs}:${mnts
              .toString()
              .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

            countdownShort = `${days} DAYS ${hrs}:${mnts
              .toString()
              .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
          }

          // Scope to this banner's own container: a document-wide lookup by
          // index breaks on reorder, on expand/collapse, and across instances
          const bannerEl = bannerRefs.current[banner?.id];
          const container = bannerEl?.getElementsByClassName(
            "livestream-floating-timer-container"
          )[0];
          const containerShort = bannerEl?.getElementsByClassName(
            "livestream-floating-short-timer-container"
          )[0];
          if (container) {
            container.innerHTML = countdown;
          }
          if (containerShort) {
            containerShort.innerHTML = countdownShort;
          }
        }, 1000);
      }

      return {
        index,
        hasTimer,
        endEpoch,
        timerInterval,
        countdown,
      };
    });

    timerObj.current = timerObjects || [];
  };
  const organizeBannerTimerObj = (banners) => {
    // This runs again on every refetch/re-render of the banner list effect —
    // without this the old intervals keep writing their own dates to the same node
    timerObj.current.forEach((count) => clearInterval(count?.timerInterval));

    const newTimerObj = banners?.map((banner, index) => {
      const hasTimer = banner?.metadata?.is_countdown;
      const startEpoch = banner?.metadata?.countdown_start_date_epoch;
      const endEpoch = banner?.metadata?.countdown_end_date_epoch;
      let countdown = null;
      let copies = banner?.metadata?.copies;

      if (!hasTimer) {
        if (copies) {
          const timerInterval = setInterval(() => {
            // Set Countdown to DOM
            const timerContainer = getTimerContainer(banner, index);
            if (timerContainer) {
              timerContainer.innerHTML = copies;
              clearInterval(timerInterval);
            }
          }, 1000);

          return {
            index,
            hasTimer,
            endEpoch,
            timerInterval,
            countdown,
          };
        }

        return {
          index,
          hasTimer,
          endEpoch,
          timerInterval: null,
          countdown,
        };
      }

      const timerInterval = setInterval(() => {
        const today = moment();
        const start = moment.unix(startEpoch);
        const end = moment.unix(endEpoch);
        const readableStartDate = getReadableDateFromEpoch(startEpoch);
        const readableEndDate = getReadableDateFromEpoch(endEpoch);

        // Clear Interval if Epoch is less than 0
        if (endEpoch < 0) {
          clearInterval(timerInterval);
          return;
        }

        // Set Countdown
        if (today.isAfter(end)) {
          countdown = t("common.contest_ended");
        } else if (copies) {
          if (today.isBefore(start)) {
            countdown = copies.replace(
              ":countdown",
              `${t(
                readableStartDate.days > 1 ? "common.n_days" : "common.n_day",
                {
                  n: readableStartDate.days,
                }
              )} ${readableStartDate.hrs}:${
                readableStartDate.mnts > 9
                  ? readableStartDate.mnts
                  : `0${readableStartDate.mnts}`
              }:${
                readableStartDate.seconds > 9
                  ? readableStartDate.seconds
                  : `0${readableStartDate.seconds}`
              }`
            );
          } else if (today.isBetween(start, end)) {
            countdown = copies.replace(
              ":countdown",
              `${t(
                readableEndDate.days > 1 ? "common.n_days" : "common.n_day",
                {
                  n: readableEndDate.days,
                }
              )} ${readableEndDate.hrs}:${
                readableEndDate.mnts > 9
                  ? readableEndDate.mnts
                  : `0${readableEndDate.mnts}`
              }:${
                readableEndDate.seconds > 9
                  ? readableEndDate.seconds
                  : `0${readableEndDate.seconds}`
              }`
            );
          }
        } else {
          if (today.isBefore(start)) {
            countdown = `${t("common.starts_in")} ${t(
              readableStartDate.days > 1 ? "common.n_days" : "common.n_day",
              {
                n: readableStartDate.days,
              }
            )} ${readableStartDate.hrs}:${
              readableStartDate.mnts > 9
                ? readableStartDate.mnts
                : `0${readableStartDate.mnts}`
            }:${
              readableStartDate.seconds > 9
                ? readableStartDate.seconds
                : `0${readableStartDate.seconds}`
            }`;
          } else {
            countdown = `${t("common.ends_in")} ${t(
              readableEndDate.days > 1 ? "common.n_days" : "common.n_day",
              {
                n: readableEndDate.days,
              }
            )} ${readableEndDate.hrs}:${
              readableEndDate.mnts > 9
                ? readableEndDate.mnts
                : `0${readableEndDate.mnts}`
            }:${
              readableEndDate.seconds > 9
                ? readableEndDate.seconds
                : `0${readableEndDate.seconds}`
            }`;
          }
        }

        // Set Countdown to DOM
        const timerContainer = getTimerContainer(banner, index);
        if (timerContainer) {
          timerContainer.innerHTML = countdown;
          // Only stop once "ended" has actually been written to the DOM
          if (today.isAfter(end)) {
            clearInterval(timerInterval);
          }
        }
      }, 1000);

      return {
        index,
        hasTimer,
        endEpoch,
        timerInterval,
        countdown,
      };
    });

    timerObj.current = newTimerObj || [];
  };
  // Look the node up by banner id inside THIS component's root. A document-wide
  // class lookup by index hits every mounted Banner (e.g. live + live-gaming on
  // /live), so two intervals ended up writing different dates to the same node.
  const getTimerContainer = (banner, index) =>
    rootRef.current?.querySelector(
      `[data-banner-timer="${banner?.id ?? index}"]`
    );
  const getReadableDateFromEpoch = (epoch) => {
    // Convert Epoch to Seconds
    let epochToSeconds = epoch - moment().unix();

    // Convert Seconds to Days, Hours, Minutes, Seconds
    const days = Math.floor(epochToSeconds / (3600 * 24));
    epochToSeconds -= days * 3600 * 24;
    const hrs = Math.floor(epochToSeconds / 3600);
    epochToSeconds -= hrs * 3600;
    const mnts = Math.floor(epochToSeconds / 60);
    epochToSeconds -= mnts * 60;
    const seconds = epochToSeconds;

    return { days, hrs, mnts, seconds };
  };
  const requireRadius = () => {
    if (type === "search") {
      return true;
    } else {
      return false;
    }
  };
  const requireBottomSpace = () => {
    if (type === "search") {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div
      id="banner-subcomponent"
      ref={rootRef}
      className={Object.values(expandBanner).some(Boolean).toString()}
    >
      {type === "livestream" ? (
        <div className="expandable-floating-container">
          {livestreamBanners?.map((banner) => (
            <div
              key={banner?.id}
              ref={(el) => {
                bannerRefs.current[banner?.id] = el;
              }}
              className={`base-container default-floating-banner-gradient ${
                banner?.metadata?.template
              } ${expandBanner[banner?.id] ? "expand-banner" : ""}`}
            >
              <div
                className="banner-image-container"
                onClick={() => onExpandBanner(banner)}
              >
                <img className="banner-image" src={banner?.asset_url} />
              </div>

              {!expandBanner[banner?.id] && banner?.metadata?.is_countdown && (
                <div
                  className="livestream-floating-short-timer-container"
                  style={{
                    display: expandBanner[banner?.id] ? "none" : "block",
                  }}
                ></div>
              )}

              {expandBanner[banner?.id] && (
                <div
                  className={`banner-description-container ${
                    expandBanner[banner?.id] ? "expanded" : ""
                  }`}
                  style={{
                    display: expandBanner[banner?.id] ? "block" : "none",
                  }}
                  onClick={() => onOpenLink(banner)}
                >
                  <div
                    className="banner-description-label"
                    style={{ color: banner?.metadata?.title_font_color }}
                  >
                    {banner?.title}
                  </div>
                  <div style={{ padding: 1 }} />
                  {banner?.metadata?.is_countdown && (
                    <div
                      className="livestream-floating-timer-container"
                      style={{ color: banner?.metadata?.title_font_color }}
                    ></div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        carouselView
      )}
    </div>
  );
};

export default Banner;
